import { ReduxRoot } from 'types/ReduxStore'
import { REDUX_PLUS_LOAD_EXCEPTION_MODAL_STORE_KEY } from './PlusLoadExceptionModal.reducer'

const selectPlusLoadExceptionModalStore = (state: ReduxRoot) => state[REDUX_PLUS_LOAD_EXCEPTION_MODAL_STORE_KEY]

export default selectPlusLoadExceptionModalStore
